import * as yup from 'yup';
import inputErrors from 'common/messages/inputErrors';
import moment from 'moment-timezone';

export const ChangeStatusSchema = yup.object().shape({
  terminationDate: yup
    .string()
    .nullable()
    .trim()
    .test(
      'isSameOrAfter',
      () => inputErrors.futureOrTodayDate,
      date => {
        if (!date) {
          return true;
        }

        return moment(date)
          .local()
          .isSameOrAfter(moment().startOf('day'));
      },
    ),
});
